import { createFileRoute, Outlet } from "@tanstack/react-router";

// Sending (#642): a pathless layout, not a page of its own — same pattern as
// `developer.tsx`. It used to render the transactional/publication contrast
// table, the email-approval-webhook form and a 5-tab `SendingNav` bar
// (#593). The refreshed IA moved that content to Developer settings and
// nested Templates/Event logs/Bounces directly under this layout, so
// rendering that chrome here duplicated it (D-638-3); the sidebar IA reorg
// then retired Developer settings too — the contrast table is gone and the
// webhook form has its own route (`/developer/webhook`).
// `sending/templates`, `sending/events` and `sending/bounces`
// keep these exact paths (nav already points at them) but are now
// standalone pages, not tabs inside a shared shell. See D-642-3 in
// DECISIONS.md.
// On `component: Outlet` rather than an inline arrow, see `posts.tsx`.
export const Route = createFileRoute("/dashboard/w/$workspaceId/sending")({
  component: Outlet,
});
